import { render } from "./Errors.vue?vue&type=template&id=18075717"
import script from "./Errors.vue?vue&type=script&lang=js"
export * from "./Errors.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrisrooster/Documents/Sites/mycelium/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__